/**
 * A section is a container that can be collapsed, usually a sub-container of
 * another container and usually contains only cards.
 */
export const isSection = node => {
  return node.type === 'CONTAINER' && !!node.layout.collapsible;
};